import type { PeriodId, RolloverDecision } from '@/domain'

import type { CentimeClient } from './supabase'

/** Mois passés encore ouverts (du plus ancien au plus récent) : un bilan est à faire. */
export async function listOpenPastPeriods(
  client: CentimeClient,
  current: PeriodId,
): Promise<PeriodId[]> {
  const { data, error } = await client
    .from('budget_periods')
    .select('id')
    .eq('status', 'open')
    .lt('id', current)
    .order('id')
  if (error) throw error
  return data.map((row) => row.id)
}

export type CloseResult = { ok: true } | { ok: false; code: string }

/**
 * Clôture un mois : fige ses soldes et applique les décisions de report des enveloppes
 * « demander » (les autres suivent leur règle). La base vérifie tout (spec §5.1).
 */
export async function closePeriod(
  client: CentimeClient,
  periodId: PeriodId,
  decisions: Record<string, RolloverDecision>,
): Promise<CloseResult> {
  const { data, error } = await client.rpc('close_period', {
    p_period_id: periodId,
    p_decisions: decisions,
  })
  if (error) throw error
  const result = data as { ok?: unknown; error?: { code?: unknown } } | null
  if (result?.ok === true) return { ok: true }
  const code = typeof result?.error?.code === 'string' ? result.error.code : 'unknown'
  return { ok: false, code }
}
